import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Row } from "antd";

import Language from "./language";
import csCZ from "antd/locale/cs_CZ";
import enGB from "antd/locale/en_GB";
import { LANGUAGE_SET } from "../../../modules/redux/actionNames";

import "./index.css";

export const czech = "cs";
export const english = "en";
export const czechLocale = "cs-CZ";
export const languageKey = "language";

const Languages = ({ onLanguageSetting }) => {
  const intl = useIntl();
  const [languages] = useState([
    {
      name: intl.formatMessage({
        id: "czechLanguage",
        defaultMessage: "čeština",
      }),
      iso6391Code: "cs",
      localization: "cs-CZ",
    },
    {
      name: intl.formatMessage({
        id: "englishLanguage",
        defaultMessage: "angličtina",
      }),
      iso6391Code: "en",
      localization: "en-GB",
    },
  ]);

  const dispatch = useDispatch();
  const [activeLanguage, setActiveLanguage] = useState(czech);
  const handleLanguageSet = useCallback(
    (language, languageChange = true) => {
      language =
        language ||
        (languages &&
          languages.find &&
          navigator.language &&
          languages.find(
            (l) => l.iso6391Code === navigator.language.split("-")[0]
          ));
      if (language) {
        dispatch({
          type: LANGUAGE_SET,
          language,
        });
        setActiveLanguage(language.iso6391Code);
        onLanguageSetting({
          locale: language.localization,
          antLocale: language.iso6391Code === english ? enGB : csCZ,
        });
        if (languageChange) {
          localStorage.setItem(languageKey, JSON.stringify(language));
        }
      }
    },
    [dispatch, languages, onLanguageSetting]
  );

  useEffect(() => {
    const language = localStorage.getItem(languageKey);
    handleLanguageSet(language && JSON.parse(language), false);
  }, [handleLanguageSet]);

  return (
    <Row gutter={30} align="middle" justify="space-around">
      {languages && languages !== "e" ? (
        languages.map((l, i) => (
          <Language
            key={i}
            language={l}
            title={l.name}
            span={24 / languages.length}
            languageName={l.iso6391Code}
            onLanguageClick={handleLanguageSet}
            active={activeLanguage === l.iso6391Code}
          />
        ))
      ) : (
        <Language
          active
          title={
            <FormattedMessage id="czechLanguage" defaultMessage="čeština" />
          }
          languageName={czech}
          onLanguageClick={handleLanguageSet}
        />
      )}
    </Row>
  );
};

export default Languages;
